import $ from "jquery";
import _ from "underscore";

import LayoutManager from "./LayoutManager";

// global(s)
var $window = $(window);

// création des contrôleurs
$window.on("scuba:contentReady", function(event, node) {
  $(node)
    .find(".js-scuba__menu")
    .each(function(i, menu) {
      new Scuba_Menu(menu);
    });
});

/* --------------------------------------------------

    CLASSE

-------------------------------------------------- */

function Scuba_Menu(menu) {
  this.$menu = $(menu); // raccourci jQuery
  this.$body = $("body");
  this.uid = _.uniqueId("scuba-"); // id unique

  // stocke l'instance pour exposer les méthodes
  // TODO : http://stackoverflow.com/questions/1117086/how-to-create-a-jquery-plugin-with-methods
  this.$menu.data("ScubaMenuController", this);

  /* -------------------------
        CONFIGURATION
    ------------------------- */

  this.config = {
    submenu: {
      // Doivent correspondre aux transitions CSS
      enterDuration: 400,
      leaveDuration: 300,

      // À désactiver pour économiser des calculs
      scrollEventOnProgress: true
    }
  };

  /* -------------------------
        VARIABLES
    ------------------------- */

  // à rédiger !?!
  this.isWalking = false;

  // liste des sections de sous menus
  this.$sections = $();

  /* -------------------------
        RACCOURCIS
    ------------------------- */

  this.$main = $(".js-scuba__main").first();

  // page parente
  this.$page = this.$menu.closest(".js-scuba__page, .js-scuba__head");
  this.$page.addClass("dgt-menuwrap");

  // section parente
  this.$section = this.$menu.closest(".js-scuba__section");
  this.$section.addClass("js-scuba__rootmenu");

  // liens pointants vers un sous-menu
  this.$submenuLinks = this.$menu.find("li:has(> ul) > a");

  /* -------------------------
        ECOUTEURS
    ------------------------- */

  // pour nettoyage de la mémoire
  this.$page.on("scuba:dispose", $.proxy(this.dispose, this));

  // écoute le changement des pages affichée
  $window.on(
    "scuba:stateChange." + this.uid,
    $.proxy(this.stateChangeHandler, this)
  );

  // écoute le liens vers les sous-menu
  this.$submenuLinks.on("click", $.proxy(this.submenuLinkClickHandler, this));
  // écoute tous les autres liens
  this.$menu
    .find("a")
    .not(this.$submenuLinks)
    .on("click", $.proxy(this.linkClickHandler, this));
}

$.extend(Scuba_Menu.prototype, {
  dispose: function() {
    $window.off("." + this.uid);
    this.$main.off("." + this.uid);
  },

  setWalkingMode: function(isWalking /*= true*/) {
    if (isWalking !== false) isWalking = true;

    // enregistre pour la suite
    this.isWalking = isWalking;

    this.$menu
      .toggleClass("doing-walk", isWalking)
      .toggleClass("doing-nav", !isWalking);

    this.$sections
      .find("> ul")
      .toggleClass("doing-walk", isWalking)
      .toggleClass("doing-nav", !isWalking);

    this.$main.toggleClass("is-overlaid", isWalking);

    if (isWalking) {
      this.$main.on("click." + this.uid, () => {
        this.$page
          .find(".is-active")
          .last()
          .click();
      });
    } else {
      this.$main.off("." + this.uid);
    }
  },

  stateChangeHandler: function(event, state) {
    // mode : navigation
    this.setWalkingMode(false);
    // ouvre les bons menus
    this.closeAll();
    this.openCurrentState();

    // Matomo
    var lastPage = _.last(state);
    if (lastPage) {
      var $page = lastPage.$element;
      var url = $page.data("url");
      var isMatomo = typeof _paq != "undefined" && url != null;
      if (isMatomo) {
        if (url) _paq.push(["setCustomUrl", url]);
        _paq.push(["trackPageView"]);
      }
    }
  },

  /**
   * Ecoute le liens vers les sous-menu.
   */
  submenuLinkClickHandler: function(event) {
    const layout = LayoutManager.getAvailableLayout();
    const isMobile = layout && layout.name === "MobileLayout";
    if (!isMobile) {
      return;
    }
    // empêche le clic et la remontée de l'évènement dans le DOM
    event.preventDefault();
    event.stopPropagation();

    var $link = $(event.currentTarget);

    // mode : exploration (doit être fait avant le openSubmenu qui déclenche
    // un évènement utilisé par le layout horizontal pour cliquer sur le 1er
    // lien du sous-menu uniquement si on est en 'walk')
    this.setWalkingMode(true);
    // ajout la classe d'exploration au lien cliqué
    $link.addClass("current-walk");
    // supprime la classe de tous les autres liens voisins
    $link
      .closest("ul")
      .find("li > a")
      .not($link)
      .removeClass("current-walk");

    // ouvre le sous menu correspondant (avec transition)
    this.openSubmenu($link.next("ul"), true, true);
  },

  /**
   * Ecoute tous les autres liens.
   */
  linkClickHandler: function(event) {
    var $link = $(event.currentTarget);
    var $section = $link.closest(".js-scuba__section");

    // supprime la classe de tous les autres liens voisins
    $link
      .closest("ul")
      .find("li > a")
      .not($link)
      .removeClass("current-walk");

    // ferme toutes les section après celle du lien cliqué
    this.closeSubmenu(
      $section.nextAll(".js-scuba__submenu:not(.is-closed)"),
      true
    );
  },

  /**
   * Ouvre un sous-menu.
   */
  openSubmenu: function(
    $originalSubmenu,
    triggerEvent /*= true */,
    doTransition /*= false */
  ) {
    triggerEvent = triggerEvent !== undefined ? !!triggerEvent : true;
    doTransition = doTransition !== undefined ? !!doTransition : false;

    // récupère la section du lien
    var $originalSection = $originalSubmenu.closest(".js-scuba__section");

    // cherche une section réutilisable au lieu d'en créer une pour rien
    var $section = $originalSection.next(".js-scuba__submenu:not(.is-closed)");
    if ($section.length) {
      // si la section est déjà ouverte, on s'arrête là !
      if ($section.data("__dgtMenuRelatedTo") === $originalSubmenu.get(0)) {
        return $section.find("> :first");
      }

      // vide la section trouvée
      $section.empty();

      // termine les transitions en cours
      $section.finish("dgtMenuEnter").finish("dgtMenuLeave");
      // annule la demande de transitions
      doTransition = false;

      // ferme les suivantes sections suivantes
      this.closeSubmenu($section.nextAll(".js-scuba__submenu:not(.is-closed)"));
    } else {
      // s'il n'y en a pas, on en créé une nouvelle
      $section = $(
        '<div class="js-scuba__section js-scuba__submenu c-scuba-layout__section"></div>'
      );
      // l'ajoute à la liste des sections
      this.$sections = this.$sections.add($section);
    }
    // console.log($originalSubmenu.siblings("a")[0].getAttribute("href"));

    // clone et initialise le sous-menu (et les écouteurs d'évènements)
    var $submenu = $originalSubmenu.clone(true).show();
    if (this.$body.hasClass("scuba-append-parent-to-submenus")) {
      var $prevLinkTemplate = $(
        '<div style="display:none;">' +
          '<li class="c-scuba-menu__item subitems">' +
          '<a href="#" class="c-scuba-menu__link c-scuba-menu__link--prev-link js-scuba__menu__prev-link">' +
          '<i class="chevron left"></i>' +
          "</a>" +
          "</li>" +
          '<li class="c-scuba-menu__item subitems">' +
          '<a class="js-scuba__menu__prev-link__href parent_link">' +
          '<span class="js-scuba__menu__prev-link__text"></span>' +
          "</a>" +
          "</li>" +
          "</div>"
      );
      var $prev = $($prevLinkTemplate.html());
      $prev
        .find(".js-scuba__menu__prev-link__text")
        .text($originalSubmenu.siblings("a").text());
      $prev
        .find(".js-scuba__menu__prev-link__href")[0]
        .setAttribute(
          "href",
          $originalSubmenu.siblings("a")[0].getAttribute("href")
        );
      $prev.prependTo($submenu);
    }
    $submenu.toggleClass("doing-walk", this.isWalking);
    $submenu.toggleClass("doing-nav", !this.isWalking);
    $submenu.appendTo($section);

    // ajoute les classes spécifiques à la section
    $section.addClass($submenu.data("class-submenu"));
    $section.data("__dgtMenuRelatedTo", $originalSubmenu.get(0));
    // l'ajoute la nouvelle section au DOM
    $section.insertAfter($originalSection);
    // initialise la navigation
    if (this.$menu.is(".js-scuba__nav")) {
      $submenu.scubaNav();
    }

    if (doTransition) {
      // initialisation
      $section.addClass("enter");

      // animation
      $section.animate(
        { dgtMenu: 0 },
        {
          queue: "dgtMenuEnter",
          duration: this.config.submenu.enterDuration,
          start: function() {
            $section.addClass("enter-active");
          },
          progress: this.config.submenu.scrollEventOnProgress
            ? function() {
                $window.trigger("scroll");
              }
            : null,
          complete: function() {
            $window.trigger("scroll");
            $section.removeClass("enter enter-active");
          }
        }
      );

      // attend la prochaine frame pour lancer l'animation
      setTimeout(function() {
        $section.dequeue("dgtMenuEnter");
      });
    }

    // déclenche l'évènement
    triggerEvent && this.$menu.trigger("submenuOpened", $section.get(0));

    // ajoute une classe à la page selon le niveau de profondeur
    var at = this.$sections.length;
    this.$page.removeClass(
      "dgt-menuwrap-at-" + this.$page.data("dgt-menuwrap-at")
    );
    this.$page.addClass("dgt-menuwrap-at-" + at).data("dgt-menuwrap-at", at);

    return $submenu;
  },

  /**
   * Ferme une section de sous-menu.
   */
  closeSubmenu: function($section, doTransition /*= false */) {
    if (!$section || !$section.length) return;
    doTransition = doTransition !== undefined ? !!doTransition : false;

    if (doTransition) {
      // initialisation
      $section.addClass("is-closed leave");

      // animation
      $section.animate(
        { dgtMenu: 0 },
        {
          queue: "dgtMenuLeave",
          duration: this.config.submenu.leaveDuration,
          start: function() {
            $section.addClass("leave-active");
          },
          progress: this.config.submenu.scrollEventOnProgress
            ? function() {
                $window.trigger("scroll");
              }
            : null,
          complete: function() {
            setTimeout(function() {
              $window.trigger("scroll");
            });
            $section.removeClass("leave leave-active").remove();
          }
        }
      );

      // attend la prochaine frame pour lancer l'animation
      setTimeout(function() {
        $section.dequeue("dgtMenuLeave");
      });
    } else {
      $section.remove();
    }

    // supprime la section de la liste
    this.$sections = this.$sections.not($section);

    // ajoute une classe à la page selon le niveau de profondeur
    var at = this.$sections.length;
    this.$page.removeClass(
      "dgt-menuwrap-at-" + this.$page.data("dgt-menuwrap-at")
    );
    this.$page.addClass("dgt-menuwrap-at-" + at).data("dgt-menuwrap-at", at);

    // déclenche les évènements
    this.$menu.trigger("submenuClosed");
    this.$sections.length <= 0 && this.$menu.trigger("allSubmenuClosed");
  },

  /**
   * Demande l'ouverture des sous-menus correspondant liens actifs.
   */
  openCurrentState: function($menu) {
    var isRoot = !$menu;
    if (!$menu) $menu = this.$menu;

    // cherche un lien actif
    var $link = $menu.find("ul a.is-active:eq(0)");
    if ($link.length) {
      $menu = this.openSubmenu($link.closest("ul"));
      // récursif pour les sous-sous-menus
      this.openCurrentState($menu);
    }
    // si on n'a vraiment aucun lien, on ferme tout
    else if (isRoot) {
      this.closeAll(true);
    }
  },

  /**
   * Demande la fermeture du dernier niveau de sous-menu.
   */
  closeLastSubmenu: function() {
    if (this.$sections.length < 1) return false;

    this.closeSubmenu(this.$sections.last());

    return true;
  },

  /**
   * Ferme tous les sous-menus.
   */
  closeAll: function(doTransition) {
    this.closeSubmenu(this.$sections, doTransition);
  }
});

export default Scuba_Menu;



// WEBPACK FOOTER //
// ./scripts/scuba/Menu.js